var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditEmailAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.39 5.093L14.9 1.598 16.046.451A1.528 1.528 0 0117.206 0a1.62 1.62 0 011.16.478l1.173 1.174a1.649 1.649 0 010 2.293zM.819 20A.794.794 0 010 19.181v-2.348a.8.8 0 01.055-.3.832.832 0 01.191-.273L13.752 2.745l3.492 3.495L3.738 19.755a.831.831 0 01-.273.191.8.8 0 01-.3.055z",
    opacity: 0.6
  })));
}
export default SvgEditEmailAndroid;